import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserListState } from '../models/users.model';
import { USER_LIST_FEATURE_KEY } from './users.reducer';

/**
 * Feature selector for user list state
 */
export const selectUserListState = createFeatureSelector<UserListState>(
  USER_LIST_FEATURE_KEY
);

/**
 * Select all users
 */
export const selectUserListUsers = createSelector(
  selectUserListState,
  state => state?.users || []
);

/**
 * Select user list rows
 */
export const selectUserListRows = createSelector(
  selectUserListState,
  state => state?.rows || []
);

/**
 * Select loading state
 */
export const selectUserListLoading = createSelector(
  selectUserListState,
  state => state?.loading || false
);

/**
 * Select error state
 */
export const selectUserListError = createSelector(
  selectUserListState,
  state => state?.error
);

/**
 * Select total count
 */
export const selectUserListTotal = createSelector(
  selectUserListState,
  state => state?.total || 0
);

/**
 * Select pagination state
 */
export const selectUserListPagination = createSelector(
  selectUserListState,
  state => ({
    pageIndex: state?.pageIndex || 0,
    pageSize: state?.pageSize || 10,
  })
);

/**
 * Select search query
 */
export const selectUserListSearch = createSelector(
  selectUserListState,
  state => state?.search || ''
);
